import { render, staticRenderFns } from "./job-ad-owner-menu.vue?vue&type=template&id=3d445604"
import script from "./job-ad-owner-menu.vue?vue&type=script&lang=js"
export * from "./job-ad-owner-menu.vue?vue&type=script&lang=js"
import style0 from "./job-ad-owner-menu.vue?vue&type=style&index=0&id=3d445604&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports